import { render, staticRenderFns } from "./height.vue?vue&type=template&id=5054e357&scoped=true&"
import script from "./height.vue?vue&type=script&lang=ts&"
export * from "./height.vue?vue&type=script&lang=ts&"
import style0 from "./height.vue?vue&type=style&index=0&id=5054e357&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054e357",
  null
  
)

export default component.exports